import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
// import TimerIcon from '@mui/icons-material/Timer';
import {
	Stack,
	// Stack,
	Typography,
} from '@mui/material';
import { FC, useContext } from 'react';
// import { ProductToExhaustTextSx } from '@/components/blocks/ProductDetails/styles/availability';
import { ProductImage } from '@/components/blocks/ProductImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';

export const ColorProduct: FC = () => {
	const { product } = useContext(ContentContext) as ReturnType<typeof useProductDetails> &
		ReturnType<typeof useSkuListTable>;
	const urlBaseCloudfront = 'https://dpjye2wk9gi5z.cloudfront.net';
	// const urlBaseCloudfrontWcsstore = 'https://dpjye2wk9gi5z.cloudfront.net/wcsstore/';

	const image = product?.thumbnail || '';
	const atrrs = product?.attributes;
	const color = atrrs && atrrs.length ? atrrs.find((el) => el.identifier === 'Color1') : null;
	const colorValue = color?.values[0]?.value;

	const thumbnailFormatUrl = image.replace('hclstore', 'wcsstore');
	const thumbnailUrl = `${urlBaseCloudfront}${thumbnailFormatUrl}`;

	return (
		<Stack sx={{ marginTop: '0px', mb: '10px' }}>
			<Typography
				sx={{
					fontSize: 'var(--font-size-default)',
					fontWeight: 'bold',
					color: '#2C2C2C',
				}}
			>
				{'Color'}
				<Typography
					sx={{
						fontSize: 'var(--font-size-default)',
						fontWeight: 'normal',
						color: '#2C2C2C',
						display: 'inline',
					}}
				>
					{': '}
					{colorValue}
				</Typography>
			</Typography>
			<RenderProductImg
				fullImageRaw={thumbnailUrl}
				render={(src) => (
					<ProductImage
						sx={{ mt: '5px !important', mb: '10px', width: '70px' }}
						src={src}
						alt={'mm'}
						ribbons={[]}
						isThumbnail={false}
						isSelected={true}
					/>
				)}
			/>
		</Stack>
	);
};
